
const isTouch = matchMedia('(hover:none)').matches;
const isSmall = innerWidth < 860;

/* ================= PARTICLE WAVE (no end morph) ================= */
const canvas = document.getElementById('axis-canvas');
const renderer = new THREE.WebGLRenderer({canvas, antialias:!isSmall, alpha:true});
renderer.setPixelRatio(Math.min(window.devicePixelRatio, isSmall?1.5:2));
renderer.setSize(innerWidth, innerHeight);
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(50, innerWidth/innerHeight, .1, 100);
camera.position.set(0, 1.4, isSmall?12:10);

const COUNT = isSmall ? 3000 : 8000;
const cols = isSmall?80:120;
const pos=new Float32Array(COUNT*3);
const geo=new THREE.BufferGeometry();
geo.setAttribute('position',new THREE.BufferAttribute(pos,3));
const vcols=new Float32Array(COUNT*3);
const cA=new THREE.Color(0x8d9bff), cB=new THREE.Color(0xf1d39a), cC=new THREE.Color(0xe9e8e1);
for(let i=0;i<COUNT;i++){
  const r=i%9; const c=r<2?cA:(r<3?cB:cC);
  vcols[i*3]=c.r;vcols[i*3+1]=c.g;vcols[i*3+2]=c.b;
}
geo.setAttribute('color',new THREE.BufferAttribute(vcols,3));
const mat=new THREE.PointsMaterial({vertexColors:true,size:isSmall?.045:.03,transparent:true,opacity:.9,depthWrite:false,blending:THREE.AdditiveBlending});
scene.add(new THREE.Points(geo,mat));

let tmx=0,tmy=0,mx=0,my=0,smooth=0;
const mouse3=new THREE.Vector3();
if(!isTouch){addEventListener('mousemove',e=>{tmx=(e.clientX/innerWidth-.5)*2;tmy=-(e.clientY/innerHeight-.5)*2},{passive:true})}
addEventListener('resize',()=>{camera.aspect=innerWidth/innerHeight;camera.updateProjectionMatrix();renderer.setSize(innerWidth,innerHeight)});
const clock=new THREE.Clock();
const nightStart=document.getElementById('night-start');
const nsSafe=()=>nightStart?nightStart.offsetTop:Number.MAX_SAFE_INTEGER;

function tick(){
  const t=clock.getElapsedTime();
  smooth+=(window.scrollY-smooth)*.06;
  const nsTop=nsSafe();
  const full=document.documentElement.scrollHeight-innerHeight;
  const pN=Math.min(Math.max((smooth-nsTop+innerHeight*.6)/Math.max(full-nsTop,1),0),1);
  mx+=(tmx-mx)*.05;my+=(tmy-my)*.05;

  let mwx=0,mwy=0;
  if(!isTouch){
    mouse3.set(mx,my,.5).unproject(camera);
    mouse3.sub(camera.position).normalize();
    const dist=-camera.position.z/mouse3.z;
    mwx=camera.position.x+mouse3.x*dist;
    mwy=camera.position.y+mouse3.y*dist;
  }
  const ph=t*.9+pN*4;
  for(let i=0;i<COUNT;i++){
    const i3=i*3, xx=(i%cols)/cols, zz=Math.floor(i/cols)/(COUNT/cols);
    let x=(xx-.5)*15;
    let z=(zz-.5)*11;
    let y=Math.sin(xx*8+ph)*Math.cos(zz*6+ph*.7)*(1.0+pN*.5)-1.6;
    if(!isTouch){
      const dx=x-mwx,dy=y-mwy,d2=dx*dx+dy*dy;
      if(d2<2.4){const f2=(2.4-d2)/2.4*.5;x+=dx*f2;y+=dy*f2}
    }
    pos[i3]=x;pos[i3+1]=y;pos[i3+2]=z;
  }
  geo.attributes.position.needsUpdate=true;
  camera.position.x=mx*.7;
  camera.position.y=1.4+my*.5-pN*.8;
  camera.lookAt(0,-.4,0);
  renderer.render(scene,camera);
  requestAnimationFrame(tick);
}
tick();

/* ================= SPOTLIGHT + MAGNETIC CTAS ================= */
if(!isTouch){
  const spot=document.getElementById('spotlight');
  addEventListener('mousemove',e=>{
    spot.style.setProperty('--sx',e.clientX+'px');
    spot.style.setProperty('--sy',e.clientY+'px');
  },{passive:true});
  document.querySelectorAll('.mag').forEach(b=>{
    b.addEventListener('mousemove',e=>{
      const r=b.getBoundingClientRect();
      const dx=(e.clientX-(r.left+r.width/2))/r.width;
      const dy=(e.clientY-(r.top+r.height/2))/r.height;
      b.style.transform=`translate(${dx*8}px,${dy*6}px) scale(1.05)`;
    });
    b.addEventListener('mouseleave',()=>{b.style.transform=''});
  });
}

/* ================= NIGHT TOGGLE ================= */
function nightCheck(){
  if(!nightStart){document.body.classList.remove('night');return}
  const r=nightStart.getBoundingClientRect();
  document.body.classList.toggle('night', r.top < innerHeight*.55);
}
addEventListener('scroll',nightCheck,{passive:true});
nightCheck();

/* ================= CURSOR ================= */
if(!isTouch){
  const cur=document.getElementById('cursor');
  let cx=innerWidth/2,cy=innerHeight/2,px=cx,py=cy,seen=false;
  addEventListener('mousemove',e=>{cx=e.clientX;cy=e.clientY;if(!seen){seen=true;document.body.classList.add('cursor-on')}},{passive:true});
  (function cloop(){px+=(cx-px)*.2;py+=(cy-py)*.2;cur.style.transform=`translate(${px}px,${py}px) translate(-50%,-50%)`;requestAnimationFrame(cloop)})();
  document.querySelectorAll('a,button,summary,.card,.tier,.svc,.stat,.proc').forEach(el=>{
    el.addEventListener('mouseenter',()=>cur.classList.add('big'));
    el.addEventListener('mouseleave',()=>cur.classList.remove('big'));
  });
}

/* ================= LOADER ================= */
const loader=document.getElementById('loader');
const barEl=loader.querySelector('.track i');
const lpEl=loader.querySelector('.lp');
let lp=0;
const li=setInterval(()=>{
  lp+=Math.random()*14+6;
  if(lp>=100){lp=100;clearInterval(li);
    setTimeout(()=>{loader.classList.add('done');document.body.classList.add('loaded')},420);
  }
  barEl.style.width=lp+'%';
  lpEl.textContent=Math.floor(lp)+'%';
},110);

/* ================= CLIENT PREVIEWS: provider chain + retry ================= */
/* thum.io → wordpress mshots → styled fallback. Sequential load to dodge rate limits. */
const previewImgs=[...document.querySelectorAll('.card .thumb img[data-site]')];
function providerUrls(site){
  return [
    'https://image.thum.io/get/width/1200/crop/2200/noanimate/'+site,
    'https://s0.wp.com/mshots/v1/'+encodeURIComponent(site)+'?w=1200&h=1800'
  ];
}
function loadPreview(img, attempt=0){
  const urls=providerUrls(img.dataset.site);
  if(attempt>=urls.length*2) return;            /* both providers, 2 passes */
  const url=urls[attempt%urls.length] + (attempt>=urls.length ? ((urls[attempt%urls.length].includes('?')?'&':'?')+'r='+Date.now()) : '');
  const probe=new Image();
  probe.onload=()=>{
    /* mshots returns a tiny "generating" gif first; treat small images as not-ready */
    if(probe.naturalWidth<400){ setTimeout(()=>loadPreview(img, attempt+1), 2500); return; }
    img.src=url; img.classList.add('ok');
  };
  probe.onerror=()=>setTimeout(()=>loadPreview(img, attempt+1), 1200);
  probe.src=url;
}
/* stagger: one every 700ms so we never burst the free tier */
previewImgs.forEach((img,i)=>setTimeout(()=>loadPreview(img), i*700));

/* ================= REVEALS + COUNTERS ================= */
const io=new IntersectionObserver(es=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
const cio=new IntersectionObserver(es=>{
  es.forEach(e=>{
    if(!e.isIntersecting)return;
    const el=e.target,end=+el.dataset.count,suf=el.dataset.suffix||'';
    const t0=performance.now(),dur=1400;
    (function step(now){const k=Math.min((now-t0)/dur,1);el.textContent=Math.round(end*(1-Math.pow(1-k,3)))+suf;if(k<1)requestAnimationFrame(step)})(t0);
    cio.unobserve(el);
  });
},{threshold:.5});
document.querySelectorAll('.num[data-count]').forEach(el=>cio.observe(el));

/* ================= MOBILE STICKY CTA ================= */
const sticky=document.getElementById('stickyCta');
if(sticky){
  addEventListener('scroll',()=>{
    const p=window.scrollY/Math.max(document.documentElement.scrollHeight-innerHeight,1);
    sticky.classList.toggle('show', p>.25 && p<.92);
  },{passive:true});
}
